import { charCounter } from '../../constants/post.constants';

interface DraftCharCounterProps {
  length: number;
  min: number | null;
}

// TRIL-420: live character counter for draft editors.
// Three states: loading (min null), below min, met.
export function DraftCharCounter({ length, min }: DraftCharCounterProps) {
  let text: string;
  if (min === null) {
    text = charCounter.loading(length);
  } else if (length < min) {
    text = `${charCounter.of(length, min)} — ${charCounter.toGo(min - length)}`;
  } else {
    text = charCounter.met(length);
  }
  return <p className="DRAFT__CHAR__COUNTER">{text}</p>;
}
